<template>
  <Row>
    <Col span="24" class-name="custom-col">
      <Button type="primary" size="default" @click="addUser">增加用户</Button>
    </Col>
    <Col span="24" class-name="custom-col">
      <b-table ref="bTableRef"
               :columns="columns"
               :data="userList"
               :loading="tableLoading"
               :open-action="true"
               @on-view="viewHandler"
               @on-remove="removeHandler"
      >
      </b-table>
      <b-page
        :page="page1"
        :page-size="page1.pageSize"
        :total="page1.total"
        :pageChange="getUserList"
      ></b-page>
    </Col>
    <AddUser ref="addUserRef" @add-user="addUserPost"/>
  </Row>
</template>

<script>
    import columnsMixin from './userManageTable'
    import AddUser from './common/AddUser'

    export default {
        name: 'UserManage',
        mixins: [columnsMixin],
        components: {
            AddUser
        },
        data () {
            return {
                userList: [],
                submitLoading: false
            }
        },
        created () {
            this.init()
        },
        methods: {
            init () {
                this.getUserList()
            },
            async getUserList () {
                let query = Object.assign({}, this.page1)
                this.tableLoading = true
                let { data } = await this.$http.getUserList(query)
                this.tableLoading = false
                let list = this.$utils.translateForArray(data.results || [])
                this.userList = list
                this.page1.total = data.totalRecord || 0
            },
            viewHandler (params) {
                // console.log(params)
            },
            async removeHandler ({ row: { id } }) {
                let { succ } = await this.$http.freezeUser({ id })
                if (succ) {
                    this.$Message.success('删除成功!')
                    this.getUserList()
                }
            },
            addUser () {
                this.$refs['addUserRef'].addStatus = true
            },
            async addUserPost (succ) {
                if (succ) {
                    this.$Message.success('新增用户成功!')
                    this.getUserList()
                    this.$refs['addUserRef'].cancel()
                }
            },
            async changeStatus ({ row: { id } }, status) {
                let { succ } = await this.$http.freezeUser({ id, status: status ? 'Y' : 'N' })
                if (succ) {
                    let str = status ? '启用成功!' : '禁用成功'
                    this.$Message.success(str)
                    this.getUserList()
                }
            },
            async resetPassword ({ row: { id } }) {
                this.submitLoading = true
                let { succ } = await this.$http.resetPassword({ userId: id })
                if (succ) {
                    let str = '重置成功'
                    this.$Message.success(str)
                    this.getUserList()
                }
                this.submitLoading = false
            }

        }
    }
</script>

<style scoped lang="less">
  @import "~@/common/style/base.less";
</style>
